"use strict";

exports.__esModule = true;
exports.default = void 0;
var _index = require("../../../swcp-base/js/index");
class Actions extends _index.ActionHelper {
  constructor() {
    super({
      singular: 'weblink',
      plural: 'weblinks'
    });
  }
}
const actions = new Actions();
var _default = exports.default = actions;
module.exports = exports.default;